// stejné komponenty je potřeba přidat i do next/packages/web/component/scramjet/configureWebComponents.ts
import FileInput from '@fg/fg-frontend/src/components/fileInput/FileInput';
import Form from '@fg/fg-frontend/src/components/formWithLiveValidation/Form';
import RadioSelect from '@fg/fg-frontend/src/components/RadioSelect';
import ButtonSubmit from '@fg/fg-frontend/src/components/formWithLiveValidation/ButtonSubmit';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'RadioSelect':
      return RadioSelect;
    case 'FileInput':
      return FileInput;
    case 'Form':
      return Form;
    case 'ButtonSubmit':
      return ButtonSubmit;
    default:
      console.log(`Unknown component ${props.decorator || props.is}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js